// extracted by mini-css-extract-plugin
module.exports = {"container":"loader-module--container--31Y2e","spinner":"loader-module--spinner--2KabV","spin":"loader-module--spin--1RQ9n","heading":"loader-module--heading--11ypc"};